import { Flex, Box, Input } from '@chakra-ui/react'
import { Dispatch, SetStateAction } from 'react'
import { IoIosSearch } from 'react-icons/io'

export const SearchBar = ({
  placeholder,
  setSearch,
  search,
}: {
  placeholder: string
  setSearch: Dispatch<SetStateAction<string>>
  search: string
}) => {
  return (
    <Flex px={3} gap={3} alignItems={'center'} bg={'ninja.500'} rounded={'xl'} h={'44px'}>
      <Box color={'ninja.200'}>
        <IoIosSearch size={'20px'} />
      </Box>
      <Input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        variant={'unstyled'}
        placeholder={placeholder}
        fontWeight={700}
        color={'white'}
        _placeholder={{
          fontWeight: '700',
          color: 'ninja.200',
        }}
      />
    </Flex>
  )
}
